import equals from 'shallow-equals'

export default function memoize(fn, o = {}) {
	let size = o.size || 3
	let callback = o.callback
	let cache = []
	return function () {
		let n = cache.length
		for (let i = 0; i < n; i++) {
			let x = cache[i]
			if (equals(x.args, arguments)) {
				for (let j = i - 1; j >= 0; j--) {
					cache[j + 1] = cache[j]
				}
				cache[0] = x
				return x.result
			}
		}
		if (callback) {
			var t1 = new Date()
		}
		try {
			var result = fn.apply(this, arguments)
		} catch(e) {
			console.error(e)
			throw e
		}

		if (callback) {
			let dt = new Date() - t1
			callback(dt)
		}
		if (cache.length >= size) cache.pop()
		cache.unshift({ args: arguments, result })
		return result
	}
}



// WEBPACK FOOTER //
// ./src/utils/memoize.js